import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from '../user/user.service';
import { Topic } from './topic';
import { WebForum } from './web-forum';

@Injectable({
  providedIn: 'root'
})
export class ForumService {
  private api = inject(TslApiService);
  private user = inject(UserService);

  getForums(): Observable<WebForum[]> {
    return this.api.get('forum/all');
  }

  getForumById(id: string): Observable<WebForum> {
    return this.api.get('forum', { id });
  }

  getTopicsByForum(forumId: string, categoryId?: string, pageNumber?: number): Observable<Topic[]> {
    const query: any = { forumId };
    if (categoryId) {
      query.categoryId = categoryId;
    }
    if (pageNumber) {
      query.pageNumber = pageNumber;
    }
    return this.api.get('forum/topics', query);
  }

  createTopic(
    forumId: string,
    categoryId: string,
    title: string,
    description: string
  ): Observable<Topic> {
    return this.api.post<Topic>('topic', { forumId, categoryId, title, description }).pipe(
      tap(() => {
        this.user.updateCurrentUser();
      })
    );
  }
}
